export const COMPANY_STORAGE_LOCATION_LIST = "COMPANY_STORAGE_LOCATION_LIST";
export const COMPANY_STORAGE_LOCATION_LIST_SUCCESS = "COMPANY_STORAGE_LOCATION_LIST_SUCCESS";
export const COMPANY_STORAGE_LOCATION_LIST_FAILURE = "COMPANY_STORAGE_LOCATION_LIST_FAILURE";

export const COMPANY_STORAGE_LOCATION_DATA = "COMPANY_STORAGE_LOCATION_DATA";
export const COMPANY_STORAGE_LOCATION_DATA_SUCCESS = "COMPANY_STORAGE_LOCATION_DATA_SUCCESS";
export const COMPANY_STORAGE_LOCATION_DATA_FAILURE = "COMPANY_STORAGE_LOCATION_DATA_FAILURE";

export const COMPANY_STORAGE_LOCATION_CREATE = "COMPANY_STORAGE_LOCATION_CREATE";
export const COMPANY_STORAGE_LOCATION_CREATE_SUCCESS = "COMPANY_STORAGE_LOCATION_CREATE_SUCCESS";
export const COMPANY_STORAGE_LOCATION_CREATE_FAILURE = "COMPANY_STORAGE_LOCATION_CREATE_FAILURE";

export const COMPANY_STORAGE_LOCATION_UPDATE = "COMPANY_STORAGE_LOCATION_UPDATE";
export const COMPANY_STORAGE_LOCATION_UPDATE_SUCCESS = "COMPANY_STORAGE_LOCATION_UPDATE_SUCCESS";
export const COMPANY_STORAGE_LOCATION_UPDATE_FAILURE = "COMPANY_STORAGE_LOCATION_UPDATE_FAILURE";

export const COMPANY_STORAGE_LOCATION_DELETE = "COMPANY_STORAGE_LOCATION_DELETE";
export const COMPANY_STORAGE_LOCATION_DELETE_SUCCESS = "COMPANY_STORAGE_LOCATION_DELETE_SUCCESS";
export const COMPANY_STORAGE_LOCATION_DELETE_FAILURE = "COMPANY_STORAGE_LOCATION_DELETE_FAILURE";
